import React, { useRef, useState, useEffect } from 'react'
import { Button } from 'antd'
import { useReactToPrint } from 'react-to-print'
import { CotizacionCartaFactura } from './CotizacionCartaFactura'
import { CotizacionCartaComanda } from './CotizacionCartaComanda'
import { CotizacionTicketComanda } from './CotizacionTicketComanda'

const ContentModalMain = ({ getQuote, getProductsNotAvailable, companyCountryName }) => {
  const [total, setTotal] = useState(0)
  const [flag, setFlag] = useState(false)

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <CotizacionCartaFactura ref={componentRef} getQuote={getQuote} />
      case 2:
        return <CotizacionCartaComanda ref={componentRef} getQuote={getQuote} />
      case 3:
        return <CotizacionTicketComanda ref={componentRef} getQuote={getQuote} />
      default:
        break;
    }
  }

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [total, flag])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const handleFlagPrint = (key) => {
    setTotal(key)
    setFlag(!flag)
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'none' }}>{returnPrint(total)}</div>
      <br></br>
      {
        <div style={{ display: 'grid', justifyContent: 'center' }}>
          <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => handleFlagPrint(1)}>
            Imprimir cotizacion
          </Button>

          <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => { getQuote.store.company.country.name === 'Honduras' ? handleFlagPrint(2) : handleFlagPrint(3) }}>
            Imprimir comanda
          </Button>

          <Button onClick={() => getProductsNotAvailable()} style={{ backgroundColor: "rgb(205, 205, 205)", color: 'white', borderColor: '#cdcdcd' }} className="title-tendero new-button" >
            Ver inventario bajo
          </Button>
          {!getQuote?.quote_invoice?.fel_hondura && companyCountryName === 'Honduras' && <span style={{ color: 'red', marginTop: '1rem', fontSize: 'large' }} >{'No posee ninguna credencial activa para Honduras'}</span>}
        </div>
      }
    </div >
  )
}

export default ContentModalMain